var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import React from 'react';
import classNames from 'classnames';
import injectElement from './injectElement';
import { propsDiff, setSvgAttr } from './utils';
var Icon = /** @class */function (_super) {
  __extends(Icon, _super);
  function Icon() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.prefixCls = 'ab-icon';
    _this.wrapperRef = /*#__PURE__*/React.createRef();
    _this.getUrl = function (name) {
      return "".concat(_this.props.baseUrl || Icon.baseUrl, "/").concat(name, ".svg");
    };
    _this.onChangeSvgAttr = function () {
      var element = _this.wrapperRef.current;
      if (element && element.firstChild instanceof SVGSVGElement) {
        setSvgAttr(element.firstChild, _this.props);
      }
    };
    _this.onIconClick = function (ev) {
      // 阻止冒泡
      if (ev && _this.props.onClick) {
        ev.stopPropagation();
        ev.preventDefault();
        if (ev.nativeEvent && ev.nativeEvent.stopImmediatePropagation) {
          ev.nativeEvent.stopImmediatePropagation();
        }
        _this.props.onClick();
      }
    };
    return _this;
  }
  Icon.setConfig = function (config) {
    Icon.baseUrl = config.baseUrl;
  };
  Icon.prototype.componentDidMount = function () {
    this.addSvg();
  };
  Icon.prototype.componentDidUpdate = function (prevProps) {
    if (propsDiff(prevProps, this.props)) {
      // 若修改图标，将重新创建
      if (prevProps.name !== this.props.name) {
        this.removeSVG();
        this.addSvg();
        return;
      }
      // 只修改svg样式
      this.onChangeSvgAttr();
    }
  };
  Icon.prototype.componentWillUnmount = function () {
    this.removeSVG();
  };
  Icon.prototype.addSvg = function () {
    var element = this.wrapperRef.current;
    if (!element) {
      return;
    }
    var _a = this.props,
      name = _a.name,
      width = _a.width,
      height = _a.height,
      fill = _a.fill,
      rotate = _a.rotate,
      spin = _a.spin,
      svgStyle = _a.svgStyle;
    var url = this.getUrl(name);
    injectElement(element, url, {
      width: width,
      height: height,
      fill: fill,
      rotate: rotate,
      spin: spin,
      svgStyle: svgStyle
    });
  };
  Icon.prototype.removeSVG = function () {
    var element = this.wrapperRef.current;
    // 删除子元素
    while (element.hasChildNodes()) {
      element.removeChild(element.firstChild);
    }
  };
  Icon.prototype.render = function () {
    var _a = this.props,
      Wrapper = _a.defaultWrapper,
      className = _a.className,
      onMouseDown = _a.onMouseDown,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      onTouchEnd = _a.onTouchEnd,
      onTouchStart = _a.onTouchStart,
      width = _a.width,
      height = _a.height;
    return /*#__PURE__*/React.createElement(Wrapper
    // @ts-ignore
    , {
      // @ts-ignore
      ref: this.wrapperRef,
      style: {
        width: width,
        height: height
      },
      className: classNames(className, this.prefixCls),
      onClick: this.onIconClick,
      onMouseDown: onMouseDown,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onTouchStart: onTouchStart,
      onTouchEnd: onTouchEnd
    });
  };
  Icon.defaultProps = {
    defaultWrapper: 'span',
    spin: false
  };
  return Icon;
}(React.PureComponent);
export default Icon;